import React from 'react';
import { useHistory } from 'react-router-dom';

import Button from '../../components/UI/Button';

import illustration from '../../assets/Illustration.png';
import styles from './Welcome.module.css';

const Welcome: React.FC = () => {
  const history = useHistory();
  return (
    <div className={styles.container}>
      <img src={illustration} alt="" className={styles.illustration} />
      <h1 className={styles.header}>
        "Everyone needs a budget," they say.
        <br />
        Well fuck off, will you?
      </h1>
      <p className={styles.description}>
        It's times more important to know how much money you have, how it <br/>
        affects your runway and how to not let it evaporate in the long run. <br />
        Leave saving on coffee to penny-pinching hipsters, embrace big-boy <br />
        style accounting and investment tracking.
      </p>
      
      <Button value="Get started" onClick={() => history.push('/dashboard')}/>
    </div>
  )
}

export default Welcome;